(function () {
  var comboEl = document.getElementById('variant-combo-description');
  var dataEl = document.getElementById('variant-combo-data');
  if (!comboEl || !dataEl) return;

  var comboMap = {};
  try {
    comboMap = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.warn('variant-combo-data parse error', e);
    return;
  }

  function updateCombo(variantId) {
    var text = (comboMap[variantId] || '').trim();
    if (text) {
      comboEl.textContent = text;
      comboEl.style.display = '';
    } else {
      comboEl.textContent = '';
      comboEl.style.display = 'none';
    }
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    if (variant) updateCombo(variant.id);
  });
})();
